/**
 * 🔔 أصوات المزاد عبر Web Audio API
 * (لا تحتاج ملفات صوتية — مولّدة برمجياً)
 */

let _ctx: AudioContext | null = null;

function ctx() {
  if (_ctx) return _ctx;
  try {
    const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    _ctx = new Ctx();
  } catch { /* unsupported */ }
  return _ctx;
}

/** افتح/فعّل سياق الصوت — لازم يُستدعى في تفاعل مستخدم (iOS) */
export function unlockAudio() {
  const c = ctx();
  if (c?.state === 'suspended') c.resume?.();
}

function bell(freq: number, duration = 0.35, vol = 0.18, when = 0) {
  const c = ctx();
  if (!c) return;
  if (c.state === 'suspended') c.resume?.();
  const t = c.currentTime + when;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = 'sine';
  osc.frequency.setValueAtTime(freq, t);
  const osc2 = c.createOscillator();
  osc2.type = 'sine';
  osc2.frequency.setValueAtTime(freq * 2, t);
  const gain2 = c.createGain();
  gain2.gain.setValueAtTime(vol * 0.35, t);
  gain2.gain.exponentialRampToValueAtTime(0.0001, t + duration);
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(vol, t + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + duration);
  osc.connect(gain).connect(c.destination);
  osc2.connect(gain2).connect(c.destination);
  osc.start(t); osc2.start(t);
  osc.stop(t + duration); osc2.stop(t + duration);
}

function gavel() {
  const c = ctx();
  if (!c) return;
  if (c.state === 'suspended') c.resume?.();
  const t = c.currentTime;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = 'triangle';
  osc.frequency.setValueAtTime(120, t);
  osc.frequency.exponentialRampToValueAtTime(60, t + 0.12);
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(0.35, t + 0.005);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.18);
  osc.connect(gain).connect(c.destination);
  osc.start(t); osc.stop(t + 0.2);
  bell(880, 0.4, 0.2, 0.18);
  bell(1320, 0.5, 0.15, 0.22);
}

/** أصوات حسب المرحلة (1/2/3/بيع) أو 'bid' */
export function playStageSound(stage: number | 'bid') {
  if (stage === 1)      bell(950, 0.35, 0.16);
  else if (stage === 2) { bell(950, 0.25, 0.16); bell(1180, 0.32, 0.18, 0.16); }
  else if (stage === 3) { bell(950, 0.22, 0.18); bell(1180, 0.22, 0.18, 0.14); bell(1480, 0.45, 0.2, 0.28); }
  else if (stage === 4) gavel();
  else if (stage === 'bid') bell(660, 0.18, 0.12);
}
